// src/pages/Programs.jsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HeaderSection from "../components/programs/HeaderSection";
import EnduranceProgram from "../components/programs/EnduranceProgram";
import StrengthProgram from "../components/programs/StrengthProgram";
import SportsProgram from "../components/programs/SportsProgram";
import Footer from "../components/homepage/Footer";

export default function Programs() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Use a small timeout to ensure the element is rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 50);
    }
  }, [location]);

  return (
    <div className="w-full pt-16">
      <HeaderSection />
      <EnduranceProgram />
      <StrengthProgram />
      <SportsProgram />
      <Footer />
    </div>
  );
}
